import fourthImg from "./fourthImg.jpg";
import "./styles.css";

export default function FourthImage() {
    return (
        <img src={fourthImg} alt="Foto de Andres y Mafer" className="fourth-image"/>
    );
};